"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Invoice = exports.InvoiceStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Invoice_Participant_1 = require("./RTTI_Invoice_Participant");
var RTTI_Invoice_LineItem_1 = require("./RTTI_Invoice_LineItem");
var RTTI_Invoice_PriceComponent_1 = require("./RTTI_Invoice_PriceComponent");
var RTTI_Money_1 = require("./RTTI_Money");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var InvoiceStatusKind;
(function (InvoiceStatusKind) {
    InvoiceStatusKind["_draft"] = "draft";
    InvoiceStatusKind["_issued"] = "issued";
    InvoiceStatusKind["_balanced"] = "balanced";
    InvoiceStatusKind["_cancelled"] = "cancelled";
    InvoiceStatusKind["_enteredInError"] = "entered-in-error";
})(InvoiceStatusKind = exports.InvoiceStatusKind || (exports.InvoiceStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Invoice = t.recursion('IInvoice', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Invoice')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: (0, EnumType_1.createEnumType)(InvoiceStatusKind, 'InvoiceStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            cancelledReason: t.string,
            _cancelledReason: RTTI_Element_1.RTTI_Element,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subject: RTTI_Reference_1.RTTI_Reference,
            recipient: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            participant: t.array(RTTI_Invoice_Participant_1.RTTI_Invoice_Participant),
            issuer: RTTI_Reference_1.RTTI_Reference,
            account: RTTI_Reference_1.RTTI_Reference,
            lineItem: t.array(RTTI_Invoice_LineItem_1.RTTI_Invoice_LineItem),
            totalPriceComponent: t.array(RTTI_Invoice_PriceComponent_1.RTTI_Invoice_PriceComponent),
            totalNet: RTTI_Money_1.RTTI_Money,
            totalGross: RTTI_Money_1.RTTI_Money,
            paymentTerms: RTTI_markdown_1.RTTI_markdown,
            _paymentTerms: RTTI_Element_1.RTTI_Element,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation)
        })
    ]);
});
//# sourceMappingURL=RTTI_Invoice.js.map